<template>
  <v-main class="menu">
    <!-- Upper part -->
    <div class="menu1 waveContainer1">
      <Header />
      <div class="dateHero">
        <p
          :class="[
            'menu1_head2',
            'mb-0',
            $i18n.locale === 'ru' ? 'mobileHidden' : '',
          ]"
        >
          {{ $t("upper_date") }}
        </p>
        <p
          :class="[
            'menu1_head2',
            'mb-0',
            $i18n.locale === 'az' ? 'mobileHidden' : '',
          ]"
        >
          {{ $t("upper_date-text") }}
        </p>
      </div>
      <p class="menu1_head1 mobileHidden" id="head">
        {{ $t("upper_text_1") }} <br />
        {{ $t("upper_text_2") }}
      </p>

      <p class="menu1_head1 mobileShow" id="head">
        {{ $t("upper_text_1-mobile") }} <br />
        {{ $t("upper_text_2-mobile") }}<br />
        {{ $t("upper_text_3-mobile") }}<br />
      </p>
      <v-row class="pt-sm-3 marginBottom">
        <v-col
          cols="12"
          lg="10"
          md="11"
          sm="12"
          class="py-0 text-center d-flex flex-column justify-content-center max-width scp"
        >
          <img
            src="@/assets/images/dalga.png"
            alt="Wave background"
            class="waveImage1"
          />
          <img
            src="@/assets/images/presents_group3.png"
            alt="Presents"
            class="presents_group_img mobileHidden"
          />
          <img
            src="@/assets/images/presents_group3-mobile.png"
            alt="Presents"
            class="presents_group_img mobileShow mobile_presents_group_img"
          />
          <div class="text-center scp1">
            <button @click="toFiscalEnter" class="button_check mx-auto">
              {{ $t("conditions_uploadCheck_button") }}
            </button>
          </div>
        </v-col>
      </v-row>
    </div>

    <!-- Conditions -->
    <div id="conditions">
      <div class="py-0">
        <div class="tessContainer marginTop positionRelative">
          <div
            class="igAdContainer position-absolute top10"
            @click="toInstagram"
          >
            <img
              :src="$t('instagram_ad')"
              alt="Instagram ad"
              class="instagram_ad conditionsAdd"
            />
          </div>
          <v-row>
            <v-col
              v-for="n in 5"
              :key="n"
              cols="12"
              lg="2"
              md="6"
              sm="12"
              class="text-center condition_mt flex-19"
            >
              <div class="equalHeightBox">
                <div class="d-flex flex-row align-center ensuringJustifyCenter">
                  <p class="conditionNumber">{{ n }}</p>
                  <img
                    :src="getImage(n)"
                    :alt="`Condition ${n}`"
                    class="conditionImage"
                  />
                </div>
                <div class="d-flex flex-column conditionsMargin">
                  <p class="conditionHeader">
                    {{ $t(`conditions_${n}_big_text`) }}
                  </p>
                  <p class="conditionInfo">
                    <template v-if="n === 1 || n === 3">
                      {{ $t(`conditions_${n}_small_text_1`) }}<br />
                      {{ $t(`conditions_${n}_small_text_2`) }}
                    </template>
                    <template v-else>
                      {{ $t(`conditions_${n}_small_text`) }}
                    </template>
                  </p>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>

        <!-- "Upload check" button -->
        <div class="text-center">
          <button @click="toFiscalEnter" class="button_check mx-auto">
            {{ $t("conditions_uploadCheck_button") }}
          </button>
        </div>
      </div>
    </div>

    <div class="my-16">
      <v-row class="pt-md-10 pt-sm-3">
        <v-col
          cols="12"
          lg="10"
          md="11"
          sm="12"
          class="py-0 text-center d-flex flex-column justify-content-center max-width scp"
        >
          <img
            :src="$t('special_gift')"
            alt="Bad and present"
            class="responsive7-img mobileHidden"
          />

          <p class="menu1_head1 mobileShow">{{ $t("special_gifts_header") }}</p>
          <!-- 1 Manat = 50 Bal -->
          <p class="giftName giftname1 mobileShow font20 mb-[3rem]">
            {{ $t("special_text1") }}<br />{{ $t("special_text2") }}<br />{{
              $t("special_text3")
            }}
          </p>
          <img
            :src="$t('special_mobile')"
            alt="Bad and present"
            class="responsive7-img-mobile mobileShow"
          />
        </v-col>
      </v-row>
    </div>

    <!-- Gifts -->
    <div id="gifts">
      <v-container class="py-0 padding0" fluid>
        <p class="menu1_head1">{{ $t("gifts_header") }}</p>
        <!-- 1 Manat = 50 Bal -->
        <p class="giftName giftname1">
          {{ $t("gifts_manatbal_1") }}<br class="hidden-md-and-up" />{{
            $t("gifts_manatbal_2")
          }}
        </p>
        <div class="giftsContainer mt-[0.8rem]">
          <v-row>
            <v-col
              cols="12"
              md="6"
              lg="4"
              class="d-flex justify-center align-center flex-column"
            >
              <!-- Shopping bag -->
              <div class="gshoppingBag pAbsolute">
                <div class="pRelative">
                  <img
                    class="gshoppingBagImage"
                    src="@/assets/images/gifts/shopping_bag2.png"
                    alt="Shopping bag"
                  />
                  <p class="giftName gshoppingBagText">
                    {{ $t("gifts_shoppingBag_text") }}
                  </p>
                  <p class="gshoppingBagScore">1500</p>
                  <p class="gshoppingBagText2">{{ $t("xal") }}</p>
                  <ExchangeGiftButton
                    :item="presents[0]"
                    pos_class="gshoppingBagButton"
                  />
                </div>
              </div>
            </v-col>

            <v-col
              cols="12"
              md="6"
              lg="4"
              class="d-flex justify-center align-center flex-column"
            >
              <!-- Cup -->
              <div class="gcup pAbsolute">
                <div class="pRelative">
                  <p class="giftName gshoppingBagText">
                    {{ $t("gifts_cup_text") }}
                  </p>
                  <p class="gshoppingBagScore">2000</p>
                  <p class="gshoppingBagText2">{{ $t("xal") }}</p>
                  <img
                    class="gcupImage"
                    src="@/assets/images/gifts/cup2.png"
                    alt="Cup"
                  />
                  <ExchangeGiftButton
                    :item="presents[1]"
                    pos_class="gshoppingBagButton"
                  />
                </div>
              </div>
            </v-col>

            <v-col
              cols="12"
              md="6"
              lg="4"
              class="d-flex justify-center align-center flex-column"
            >
              <!-- T-shirt -->
              <div class="gtshirt pAbsolute">
                <div class="pRelative">
                  <p class="giftName gshoppingBagText">
                    {{ $t("gifts_tshirt_text") }}
                  </p>
                  <p class="gshoppingBagScore">2200</p>
                  <p class="gshoppingBagText2">{{ $t("xal") }}</p>
                  <img
                    class="gtshirtImage"
                    src="@/assets/images/gifts/t-shirt2.png"
                    alt="T-shirt"
                  />
                  <ExchangeGiftButton
                    :item="presents[2]"
                    pos_class="gshoppingBagButton"
                  />
                </div>
              </div>
            </v-col>

            <v-col
              cols="12"
              md="6"
              lg="4"
              class="d-flex justify-center align-center flex-column"
            >
              <!-- Tea set -->
              <div class="gteaSet pAbsolute">
                <div class="pRelative">
                  <p
                    :class="[
                      'giftName',
                      'gteaSetText',
                      $i18n.locale === 'ru' ? 'gteaSetText-ru' : '',
                    ]"
                  >
                    {{ $t("gifts_teaSet_text") }}
                  </p>
                  <p
                    :class="[
                      'gshoppingBagScore2',
                      'teaSetScore',
                      $i18n.locale === 'ru' ? 'teaSetScore-ru' : '',
                    ]"
                  >
                    3500
                  </p>
                  <p
                    :class="[
                      'gshoppingBagText3',
                      'bagText',
                      'teaSetBagText',
                      $i18n.locale === 'ru'
                        ? 'teaSetScore-ru scoretext-ru'
                        : '',
                    ]"
                  >
                    {{ $t("xal") }}
                  </p>
                  <img
                    class="gteaSetImage"
                    src="@/assets/images/gifts/tea_set2.png"
                    alt="Tea set"
                  />
                  <ExchangeGiftButton
                    :item="presents[3]"
                    :pos_class="[
                      'gshoppingBagButton',
                      'ml-3',
                      'top28',
                      $i18n.locale === 'ru' ? 'teaButton-ru' : '',
                    ]"
                  />
                </div>
              </div>
            </v-col>

            <v-col
              cols="12"
              md="6"
              lg="4"
              class="d-flex justify-center align-center flex-column"
            >
              <!-- Flight pillow -->
              <div class="gflightPillow pAbsolute">
                <div class="pRelative">
                  <p class="giftName gflightPillowText">
                    {{ $t("gifts_flightPillow_text_1") }}
                    <br />{{ $t("gifts_flightPillow_text_2") }}
                  </p>
                  <p class="gshoppingBagScore pillowScore">4500</p>
                  <p class="gshoppingBagText2 pillowText">
                    {{ $t("xal") }}
                  </p>
                  <img
                    class="gtshirtImage"
                    src="@/assets/images/gifts/flight_pillow2.png"
                    alt="Flight pillow"
                  />
                  <ExchangeGiftButton
                    :item="presents[4]"
                    pos_class="gshoppingBagButton top30"
                  />
                </div>
              </div>
            </v-col>

            <v-col
              cols="12"
              md="6"
              lg="4"
              class="d-flex justify-center align-center flex-column"
            >
              <!-- Hoodie -->
              <div class="gbackpack pAbsolute">
                <div class="pRelative">
                  <p
                    :class="[
                      'giftName',
                      'gflightPillowText',
                      'bp-1',
                      'bacpack',
                      $i18n.locale === 'ru' ? 'russian-class-text' : '',
                    ]"
                  >
                    {{ $t("gifts_backpack_text") }}
                  </p>
                  <p
                    :class="[
                      'gshoppingBagScore',
                      'backpackScore',
                      'bp-2',
                      $i18n.locale === 'ru' ? 'russian-class' : '',
                    ]"
                  >
                    6500
                  </p>
                  <p
                    :class="[
                      'gshoppingBagText2',
                      'backpackText',
                      'bp-3',
                      $i18n.locale === 'ru' ? 'russian-class-point' : '',
                    ]"
                  >
                    {{ $t("xal") }}
                  </p>
                  <img
                    class="gbackpackImage bp-4"
                    src="@/assets/images/gifts/backpack2.png"
                    alt="Backpack"
                  />
                  <ExchangeGiftButton
                    :item="presents[5]"
                    :pos_class="[
                      'gshoppingBagButton',
                      'top30',
                      'bp-8',
                      $i18n.locale === 'ru' ? 'russian-class-button' : '',
                    ]"
                  />
                </div>
              </div>
            </v-col>

            <v-col
              cols="12"
              md="6"
              lg="6"
              class="d-flex justify-center align-center flex-column"
            >
              <!-- Backpack -->

              <div class="gbag pAbsolute">
                <div class="pRelative">
                  <p class="giftName gshoppingBagText bag-1">
                    {{ $t("gifts_bag_text1") }}<br />
                    {{ $t("gifts_bag_text2") }}
                  </p>
                  <p class="gshoppingBagScore bag-2">7000</p>
                  <p class="gshoppingBagText2 bag-3">{{ $t("xal") }}</p>
                  <img
                    class="gbagImage bag-4"
                    src="@/assets/images/gifts/bag2.png"
                    alt="Bag"
                  />
                  <ExchangeGiftButton
                    :item="presents[6]"
                    pos_class="gshoppingBagButton bag-5"
                  />
                </div>
              </div>
            </v-col>

            <v-col
              cols="12"
              md="6"
              lg="6"
              class="d-flex justify-center align-center flex-column"
            >
              <!-- Bag -->

              <div class="ghoodie pAbsolute">
                <div class="pRelative">
                  <p class="giftName gshoppingBagText">
                    {{ $t("gifts_hoodie_text") }}
                  </p>
                  <p class="gshoppingBagScore">8000</p>
                  <p class="gshoppingBagText2">{{ $t("xal") }}</p>
                  <img
                    class="ghoodieImage"
                    src="@/assets/images/gifts/hoodie2.png"
                    alt="Hoodie"
                  />
                  <ExchangeGiftButton
                    :item="presents[7]"
                    pos_class="gshoppingBagButton ml-3 hoodie_btn"
                  />
                </div>
              </div>
            </v-col>

            <p class="menu1_head1 margintop1">{{ $t("gifts_phone_text1") }}</p>

            <v-col
              cols="12"
              class="d-flex justify-center align-center flex-column waveContainer minh74"
            >
              <!-- Wave image -->
              <img
                src="@/assets/images/dalga.png"
                alt="Wave background"
                class="waveImage smallHidden"
              />
              <img
                src="@/assets/images/phoneWaveMobile.png"
                alt="Wave background"
                class="waveImage smallShow"
              />
              <div class="gshoppingBag2 pAbsolute">
                <div class="pRelative">
                  <p :class="['giftName', 'gphoneText1']">
                    APPLE IPHONE 16 (256 GB)
                  </p>

                  <p
                    :class="[
                      'giftName',
                      'gphoneText2',
                      'smallHidden',
                      $i18n.locale === 'ru' ? 'russian-gphone-text2' : '',
                    ]"
                  >
                    {{ $t("gifts_phone_text2") }} <br />
                    <template v-if="$i18n.locale !== 'az'"
                      >{{ $t("gifts_phone_text3") }} <br
                    /></template>

                    {{ $t("gifts_phone_text4") }} <br />
                  </p>

                  <img
                    class="gphoneImage"
                    src="@/assets/images/gifts/packsphone.png"
                    alt="Bag"
                  />
                </div>
              </div>
              <p
                :class="[
                  'giftName',
                  'gphoneText2',
                  'smallShow',
                  'mobileText',
                  $i18n.locale === 'ru' ? 'russian-gphone-text2' : '',
                ]"
              >
                {{ $t("gifts_phone_text-mob-1") }} <br />
                {{ $t("gifts_phone_text-mob-2") }}
              </p>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </div>
    <!-- muakafat txt-->
    <div>
      <v-container fluid>
        <p class="menu1_head1 marginBottom0">
          {{ $t("mukafat_txt_1") }} <br />
          {{ $t("mukafat_txt_2") }}
        </p>

        <v-row justify="center">
          <v-col cols="12" md="4" class="d-flex justify-center">
            <div class="reward-card">
              <div class="badge card-badge">x3</div>
              <div class="label card-head-small">{{ $t("sertifikat") }}</div>
              <div class="card-head-big">{{ $t("kontakt") }}</div>
              <div class="value card-body">{{ $t("200_azn") }}</div>
            </div>
          </v-col>

          <v-col cols="12" md="4" class="d-flex justify-center">
            <div class="reward-card">
              <div class="badge card-badge">x3</div>
              <div class="label card-head-small">{{ $t("sertifikat") }}</div>
              <div class="card-head-big">{{ $t("travel") }}</div>
              <div class="value card-body">{{ $t("200_azn") }}</div>
            </div>
          </v-col>

          <v-col cols="12" md="4" class="d-flex justify-center">
            <div class="reward-card">
              <div class="badge card-badge">x3</div>
              <div class="label card-head-small">{{ $t("sertifikat") }}</div>
              <div class="card-head-big">{{ $t("fitnes_lab") }}</div>
              <div class="value card-body">{{ $t("1_ay") }}</div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- FAQ -->
    <div id="faq" class="my-16">
      <p class="menu1_head1">{{ $t("faq_header") }}</p>

      <div class="container">
        <div class="tessContainer">
          <div class="faqContainer">
            <v-row>
              <!-- Questions and Answers -->
              <v-col cols="12" lg="8" md="8" sm="12" class="questionsContainer">
                <QuestionsAnswers />
              </v-col>

              <!-- Contact Us -->
              <v-col cols="12" lg="4" md="4" sm="12" class="contactUsContainer">
                <p class="contactUsText">
                  {{ $t("faq_contactUs_1") }}<br />{{ $t("faq_contactUs_2")
                  }}<br />{{ $t("faq_contactUs_3") }}
                </p>
                <v-btn
                  class="askQuestionButton"
                  @click.prevent="toggleChatBot"
                  text
                  >{{ $t("faq_contactUs_button") }}</v-btn
                >
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
      <v-container>
        <p class="mt-10 green-text text-center">{{ $t("hot_line") }}</p>
      </v-container>
    </div>
  </v-main>
</template>

<script>
import Header from "../parts/Header.vue";
import QuestionsAnswers from "../parts/QuestionsAnswers.vue";
import ExchangeGiftButton from "../parts/ExchangeGiftButton.vue";
import axios from "axios";
import store from "@/store";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Index",
  data: () => ({
    items: [],
    presents: [
      { id: 1, value: 1500 },
      { id: 2, value: 2000 },
      { id: 3, value: 2200 },
      { id: 4, value: 3500 },
      { id: 5, value: 4500 },
      { id: 6, value: 6500 },
      { id: 7, value: 7000 },
      { id: 8, value: 8000 },
    ],
    chatBotVisible: false,
  }),
  components: { Header, QuestionsAnswers, ExchangeGiftButton },
  methods: {
    toFiscalEnter() {
      this.$router.push("/fiscalEnter").catch(() => {});
    },
    toInstagram() {
      axios.put(store.getters.getUrl + "Property/IncrementInstaCount");
      window.location.href =
        "https://www.instagram.com/tesstea.az?igsh=MXZkMG92azRjcXhvdw==";
    },
    toggleChatBot() {
      this.chatBotVisible = !this.chatBotVisible;
      this.chatBotVisible
        ? document
            .querySelector(".cc-1no03")
            .setAttribute("data-visible", "true")
        : document
            .querySelector(".cc-1no03")
            .setAttribute("data-visible", "false");
    },

    getImage(n) {
      switch (n) {
        case 1:
          return require("@/assets/images/conditions/milk.png");
        case 2:
          return require("@/assets/images/conditions/check.png");
        case 3:
          return require("@/assets/images/conditions/phone.png");
        case 4:
          return require("@/assets/images/conditions/gift5.png");
        case 5:
          return require("@/assets/images/conditions/bag_n_present.png");
      }
    },
  },
};
</script>

<style>
@import url("../../assets/css/custom.css");
</style>
